import React from "react";
import { observer } from "mobx-react";
import { ConnectedDevicesActivityTemplate } from "themes/administration/analytics/pages";
import { ConnectedDevicesActivityViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new ConnectedDevicesActivityViewStore(rootStore, componentProps),
    "connectedDevicesActivityViewStore"
)
@observer
class ConnectedDevicesActivity extends React.Component {
    render() {
        return <ConnectedDevicesActivityTemplate {...this.props} />;
    }
}

export default ConnectedDevicesActivity;
